import { useQuery } from "@tanstack/react-query"
import { FileTypeGet } from "../app/models/FileType"
import { digitalManagerApi } from "../services/api"

export function useFileTypes() {
  const { data: fileTypes = [], isLoading: isLoadingFileTypes } = useQuery({
    queryKey: ["fileTypes"],
    queryFn: () => digitalManagerApi.get<FileTypeGet[]>(`/fileTypes`).then((r) => r.data),
  })

  return {
    fileTypes,
    isLoadingFileTypes,
  }
}
